import { styled } from '@mui/system'

export const Card = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    boxShadow: `0px 4px 10px 2px ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    minHeight: 70,
    cursor: 'pointer'
}))

export const CardBody = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2.5),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    width: 'inherit',
    [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
    }
}))

export const CardContent = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(4),
    alignItems: 'center'
}))

export const CardTitle = styled('div')(({ theme }) => ({
    ...theme.typography.regularBody2,
    letterSpacing: '1px',
    lineHeight: '20px'
}))

export const CardSubTitle = styled('div')(({ theme }) => ({
    ...theme.typography.regularCaption,
    fontStyle: 'italic',
    letterSpacing: '1px',
    lineHeight: '20px'
}))

export const CardFileIcon = styled('div')({
    display: 'flex',
    alignItems: 'center'
})
